import { Autocomplete } from 'components';
import React from 'react';
import { reporting_for } from '../appConst';

/**
 * ReporterTypes - Dropdown for selecting officer type from static list.
 *
 * @param {object} props
 * @param {string} props.name - Name of the field (for form handling).
 * @param {string} [props.label] - Label for the field.
 * @param {any} props.value - Value (controlled, can be string, object, or array for multiple).
 * @param {function} props.onChange - Change handler (event, value) => void.
 * @param {boolean} [props.required] - Required field.
 * @param {Array} [props.validators] - Validation rules.
 * @param {Array} [props.errorMessages] - Validation error messages.
 * @returns {JSX.Element}
 */

const ReporterTypes = ({
    name,
    label,
    value,
    onChange,
    required = false,
    validators = [],
    errorMessages = [],
}) => {
    return (
        <div>
            <Autocomplete
                name={name}
                label={label}
                value={reporting_for.find((item) => item.value === value) || null}
                onChange={(event, newValue) => {
                    if (onChange) onChange(event, newValue?.value || '');
                }}
                options={reporting_for}
                getOptionLabel={option => option.label || ''}
                required={required}
                validators={validators}
                errorMessages={errorMessages}
            />
        </div>
    );
};

export default ReporterTypes;
